import React from 'react';
import { Card, Typography } from 'antd';
import { Colors } from '@common/tokens';

const { Title } = Typography;

type WorkerTimesheetStatsData = {
  title: string;
  showPastApproval: boolean;
  counts:
    | {
        label: string;
        value: string;
      }[]
    | undefined;
};

export const WorkerTimesheetStats = (props: {
  data: WorkerTimesheetStatsData[];
}) => (
  <div className="WorkerTimesheetStats">
    {props.data?.map((data, index) => (
      <Card
        key={index}
        className="worker-timesheet-stats-card"
        title={
          <div>
            <span className="title-text" style={{ paddingRight: '15px' }}>
              {data.title}
            </span>
            {data.showPastApproval && (
              <span className="past-approval-text">Past approval deadline</span>
            )}
          </div>
        }
        headStyle={{ backgroundColor: Colors.elmHyperlight }}
        bodyStyle={{ padding: '12px 16px 8px 16px' }}
      >
        <div id="summary-row" className="grid-container">
          {data.counts?.map((count, index) => (
            <div key={index} className={`hour-type-col-${index} grid-item`}>
              <p className="grid-item-label">{count.label}</p>
              <div className="grid-item-value">
                <Title level={4}>{count.value}</Title>
              </div>
            </div>
          ))}
        </div>
      </Card>
    ))}
    <style jsx>
      {`
        .WorkerTimesheetStats {
          display: flex;
        }

        .title-text {
          font-size: 16px;
          font-weight: 600;
        }

        .past-approval-text {
          color: ${Colors.coral};
          font-weight: 500;
        }

        .grid-container {
          display: inline-grid;
          grid-auto-flow: column;
          gap: 16px;
        }

        .grid-item {
          text-align: center;
        }

        .grid-item-label {
          margin-bottom: 4px;
        }
      `}
    </style>
  </div>
);
